/* =============================================================================
   Akademija Starfy - slike Messierjevih teles
   =============================================================================
   Naslovi kazejo na Shopify, ne na Wikimedijo: slike so prenesene enkrat, ne
   ob vsakem obisku. Ob vsaki je zapisan avtor in licenca, ker je pri CC BY in
   CC BY-SA pripis pogoj uporabe, ne vljudnost.

   Kljuc je oznaka objekta z velikimi crkami, ker jo obe poglavji zapisujeta
   drugace (m42 oziroma M42).
   ========================================================================== */
window.STARFY_SLIKE = {
 "M1": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Crab_Nebula.jpg?v=1787830298",
  "a": "NASA, ESA, J. Hester and A. Loll",
  "l": "Public domain",
  "lu": "",
  "v": "https://commons.wikimedia.org/wiki/File%3ACrab_Nebula.jpg"
 },
 "M2": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Messier2_-_HST_-_Potw1913a.jpg?v=1787830298",
  "a": "ESA/Hubble & NASA, G. Piotto et al.",
  "l": "CC BY 4.0",
  "lu": "https://creativecommons.org/licenses/by/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3AMessier2_-_HST_-_Potw1913a.jpg"
 },
 "M3": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-NASA_E2_80_99s_Hubble_Spots_Star-Spangled_Cosmic_Scene__28M3_29.jpg?v=1787830299",
  "a": "NASA, ESA, and A. Sarajedini",
  "l": "Public domain",
  "lu": "",
  "v": "https://commons.wikimedia.org/wiki/File%3ANASA%E2%80%99s_Hubble_Spots_Star-Spangled_Cosmic_Scene_(M3).jpg"
 },
 "M5": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-M5-Messier-5.png?v=1787830299",
  "a": "Chuck Ayoub",
  "l": "CC0",
  "lu": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
  "v": "https://commons.wikimedia.org/wiki/File%3AM5-Messier-5.png"
 },
 "M8": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-VST_images_the_Lagoon_Nebula.jpg?v=1787830298",
  "a": "ESO/VPHAS+ team",
  "l": "CC BY 4.0",
  "lu": "https://creativecommons.org/licenses/by/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3AVST_images_the_Lagoon_Nebula.jpg"
 },
 "M11": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Eso1430a.jpg?v=1787830299",
  "a": "ESO",
  "l": "CC BY 4.0",
  "lu": "https://creativecommons.org/licenses/by/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3AEso1430a.jpg"
 },
 "M13": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-M13-Globular-Cluster.png?v=1787830299",
  "a": "Chuck Ayoub",
  "l": "CC0",
  "lu": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
  "v": "https://commons.wikimedia.org/wiki/File%3AM13-Globular-Cluster.png"
 },
 "M15": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-M15_Globular_Cluster_from_the_Mount_Lemmon_SkyCenter_Schulman_Telescope_courtesy_Adam_Block.jpg?v=1787830298",
  "a": "Ngc1535",
  "l": "CC BY-SA 4.0",
  "lu": "https://creativecommons.org/licenses/by-sa/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3AM15_Globular_Cluster_from_the_Mount_Lemmon_SkyCenter_Schulman_Telescope_courtesy_Adam_Block.jpg"
 },
 "M22": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-The_crammed_centre_of_Messier_22.jpg?v=1787830298",
  "a": "ESA/Hubble & NASA",
  "l": "CC BY 4.0",
  "lu": "https://creativecommons.org/licenses/by/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3AThe_crammed_centre_of_Messier_22.jpg"
 },
 "M27": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Messier_27__281_29.jpg?v=1787830297",
  "a": "Alpha Zhang",
  "l": "CC BY-SA 4.0",
  "lu": "https://creativecommons.org/licenses/by-sa/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3AMessier_27_(1).jpg"
 },
 "M31": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Andromeda_Galaxy_2025.png?v=1787830299",
  "a": "Brody Wesner",
  "l": "CC0",
  "lu": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
  "v": "https://commons.wikimedia.org/wiki/File%3AAndromeda_Galaxy_2025.png"
 },
 "M33": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-VST_snaps_a_very_detailed_view_of_the_Triangulum_Galaxy.jpg?v=1787830298",
  "a": "ESO",
  "l": "CC BY 4.0",
  "lu": "https://creativecommons.org/licenses/by/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3AVST_snaps_a_very_detailed_view_of_the_Triangulum_Galaxy.jpg"
 },
 "M35": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-M35_and_NGC_2158.png?v=1787830299",
  "a": "Chuck Ayoub",
  "l": "CC0",
  "lu": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
  "v": "https://commons.wikimedia.org/wiki/File%3AM35_and_NGC_2158.png"
 },
 "M36": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-M36-pinwheel-cluster.png?v=1787830299",
  "a": "Chuck Ayoub",
  "l": "CC0",
  "lu": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
  "v": "https://commons.wikimedia.org/wiki/File%3AM36-pinwheel-cluster.png"
 },
 "M37": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-M37_Star_Cluster.png?v=1787830299",
  "a": "Chuck Ayoub",
  "l": "CC0",
  "lu": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
  "v": "https://commons.wikimedia.org/wiki/File%3AM37_Star_Cluster.png"
 },
 "M42": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Orion_Nebula_-_Hubble_2006_mosaic_18000.jpg?v=1787830298",
  "a": "NASA, ESA, M. Robberto",
  "l": "Public domain",
  "lu": "",
  "v": "https://commons.wikimedia.org/wiki/File%3AOrion_Nebula_-_Hubble_2006_mosaic_18000.jpg"
 },
 "M44": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-M44-Star-Cluster.png?v=1787830299",
  "a": "Chuck Ayoub",
  "l": "CC0",
  "lu": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
  "v": "https://commons.wikimedia.org/wiki/File%3AM44-Star-Cluster.png"
 },
 "M45": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Pleiades_large_03c320af-5beb-4f06-a1be-4d0133ada03e.jpg?v=1787830298",
  "a": "NASA, ESA, AURA/Caltech, Palomar Observatory",
  "l": "Public domain",
  "lu": "",
  "v": "https://commons.wikimedia.org/wiki/File%3APleiades_large.jpg"
 },
 "M51": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Messier51_sRGB.jpg?v=1787830298",
  "a": "NASA and European Space Agency",
  "l": "Public domain",
  "lu": "",
  "v": "https://commons.wikimedia.org/wiki/File%3AMessier51_sRGB.jpg"
 },
 "M57": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Webb_captures_detailed_beauty_of_Ring_Nebula__28NIRCam_image_29__28weic2320b_29.jpg?v=1787830298",
  "a": "ESA/Webb, NASA, CSA, M. Barlow, N. Cox, R. Wesson",
  "l": "CC BY 4.0",
  "lu": "https://creativecommons.org/licenses/by/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3AWebb_captures_detailed_beauty_of_Ring_Nebula_(NIRCam_image)_(weic2320b).jpg"
 },
 "M64": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-NGC_4826_-_HST.png?v=1787830299",
  "a": "Judy Schmidt from USA",
  "l": "CC BY 2.0",
  "lu": "https://creativecommons.org/licenses/by/2.0",
  "v": "https://commons.wikimedia.org/wiki/File%3ANGC_4826_-_HST.png"
 },
 "M65": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Messier_65_through_the_years.jpg?v=1787830299",
  "a": "ESA/Hubble & NASA",
  "l": "Public domain",
  "lu": "",
  "v": "https://commons.wikimedia.org/wiki/File%3AMessier_65_through_the_years.jpg"
 },
 "M76": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Little_Dumbbell_Nebula_M76_by_Goran_Nilsson_2C_Wim_van_Berlo__26_Liverpool_Telescope.jpg?v=1787830298",
  "a": "Göran Nilsson, Wim van Berlo & The Liverpool Telescope",
  "l": "CC BY-SA 4.0",
  "lu": "https://creativecommons.org/licenses/by-sa/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3ALittle_Dumbbell_Nebula_M76_by_Goran_Nilsson%2C_Wim_van_Berlo_%26_Liverpool_Telescope.jpg"
 },
 "M81": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Messier_81_HST.jpg?v=1787830299",
  "a": "NASA, ESA and the Hubble Heritage Team",
  "l": "Public domain",
  "lu": "",
  "v": "https://commons.wikimedia.org/wiki/File%3AMessier_81_HST.jpg"
 },
 "M82": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-M82_HST_ACS_2006-14-a-large_web.jpg?v=1787830298",
  "a": "NASA, ESA, and The Hubble Heritage Team",
  "l": "Public domain",
  "lu": "",
  "v": "https://commons.wikimedia.org/wiki/File%3AM82_HST_ACS_2006-14-a-large_web.jpg"
 },
 "M92": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-M92_Hubble_WikiSky.jpg?v=1787830299",
  "a": "en:NASA, en:STScI, en:WikiSky",
  "l": "Public domain",
  "lu": "",
  "v": "https://commons.wikimedia.org/wiki/File%3AM92_Hubble_WikiSky.jpg"
 },
 "M97": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/lossy-page1-500px-Noao-m97_tif.jpg?v=1787830298",
  "a": "NOIRLab / NSF / AURA",
  "l": "CC BY-SA 4.0",
  "lu": "https://creativecommons.org/licenses/by-sa/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3ANoao-m97.tif"
 },
 "M101": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-M101_hires_STScI-PRC2006-10a.jpg?v=1787830299",
  "a": "Image: European Space Agency & NASA",
  "l": "CC BY 4.0",
  "lu": "https://creativecommons.org/licenses/by/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3AM101_hires_STScI-PRC2006-10a.jpg"
 },
 "M104": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Sombrero_Galaxy__28heic2506a_29.jpg?v=1787830298",
  "a": "ESA/Hubble & NASA, K. Noll",
  "l": "CC BY 4.0",
  "lu": "https://creativecommons.org/licenses/by/4.0",
  "v": "https://commons.wikimedia.org/wiki/File%3ASombrero_Galaxy_(heic2506a).jpg"
 },
 "DVOJNA": {
  "u": "https://cdn.shopify.com/s/files/1/0694/8166/0719/files/960px-Double_Cluster.jpg?v=1787830299",
  "a": "Genuson",
  "l": "CC BY-SA 3.0",
  "lu": "https://creativecommons.org/licenses/by-sa/3.0",
  "v": "https://commons.wikimedia.org/wiki/File%3ADouble_Cluster.jpg"
 }
};
